<template>
    <v-sheet>
        <vertical-form-table v-model="form" v-bind="{ items }" @input="emit"></vertical-form-table>

        <terms-of-agreements-short v-model="form._terms" @input="emit" @isValid="(value) => $emit('setIsTermsValid', value)" />
    </v-sheet>
</template>

<script>
import { attrs_input, initExpoEmployer } from "@/assets/variables";

import TermsOfAgreementsShort from "@/components/client/join/terms-of-agreements-short.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const items = [
    {
        key: "info.desc",
        term: "구인기업 소개",
        type: "textarea",
        required: true,

        placeholder: "구인기업 소개를 작성하세요.",
    },
    {
        key: "info.body",
        term: "구인내용",
        type: "textarea",
        required: true,

        placeholder: "구인내용을 작성하세요.",
    },
    {
        key: "info.name",
        term: "기업명",
        type: "text",
        required: true,

        placeholder: "기업명을 입력하세요.",
    },
    {
        key: "info.worker",
        term: "담당자",
        type: "text",
        required: true,

        placeholder: "담당자를 입력하세요.",
    },
    {
        key: "info.phone",
        term: "연락처",
        type: "phone",
        required: true,
    },
    {
        key: "info.email",
        term: "이메일",
        type: "email",
        required: true,

        placeholder: "이메일을 입력하세요.",
    },
    {
        key: "info.site",
        term: "홈페이지",
        type: "text",
        required: true,

        placeholder: "홈페이지를 입력하세요.",
    },
    {
        key: "info",
        term: "주소",
        type: "address",
        required: true,
    },
].map((item) => ({
    ...attrs_input,
    ...item,
}));

export default {
    components: {
        TermsOfAgreementsShort,
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: initExpoEmployer },
    },
    data: () => ({
        form: initExpoEmployer(),

        items,
    }),
    methods: {
        sync() {
            this.form = initExpoEmployer(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style>
</style>